import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold px-2" }, "Account Settings", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold tracking-normal" }, "Company Account", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold tracking-normal" }, "Password and Authentication", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold tracking-normal" }, "Account Migration", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold tracking-normal" }, "Account Removal", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Disabling your account means you can recover it at any time after taking this action.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-primary-violet" }, " If you request to delete your account, your account will be deleted in 14 days. During this time, you can login to reactivate your account, which will cancel your deletion. After 14 days deletion will be irreversible. ", -1)
const _hoisted_8 = { class: "ion-margin-top" }
const _hoisted_9 = { class: "font-bold tracking-normal" }
const _hoisted_10 = { class: "flex flex-row gap-3" }
const _hoisted_11 = { class: "ion-margin-top" }
const _hoisted_12 = { class: "font-bold tracking-normal" }
const _hoisted_13 = { class: "flex flex-row gap-3" }
const _hoisted_14 = { class: "ion-margin-top" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold tracking-normal" }, "Change Password", -1)
const _hoisted_16 = { class: "flex flex-row gap-3" }
const _hoisted_17 = { class: "ion-margin-top flex flex-col text-center gap-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold tracking-normal" }, "Are you sure you want to migrate your account?", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("p", { class: "italic mb-5" }, "Heads up! Your current data will be overwritten by the old one.", -1)
const _hoisted_20 = { class: "flex flex-row gap-3" }
const _hoisted_21 = { class: "ion-margin-top flex flex-col text-center gap-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold tracking-normal" }, "Are you sure you want to disable your account?", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "italic mb-5" }, "Your data won't be deleted and able to use again when reactivating", -1)
const _hoisted_24 = { class: "flex flex-row gap-3" }
const _hoisted_25 = { class: "ion-margin-top flex flex-col text-center gap-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", { class: "font-bold tracking-normal" }, "Are you sure you want to delete your account?", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "italic mb-5" }, "You won't able to retrieve your account after 14 days", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "italic mb-5" }, "Please type delete below to insure you want to delete your account", -1)
const _hoisted_29 = { class: "flex flex-row gap-3" }

import { arrowBackCircle } from "ionicons/icons"
  import { IonButtons, loadingController, IonContent, IonModal, toastController } from "@ionic/vue"
  import { ref, onBeforeMount, nextTick } from "vue"
  import { generateSchema } from "@/utils/validate"
  import { useAccountStore } from "@/store/account"
  import { useAuthenticationStore } from "@/store/authentication"
  import jwt from "@/utils/jwt"
  import router from "@/router"

  import WbInput from "@/components/template/InputTemplate.vue"
  import CardTemplate from "@/components/template/CardTemplate.vue"
  import SixDigitTemplate from "@/components/template/SixdigitCode.vue"
  import FormTemplate from "@/components/template/formTemplate.vue"
  import WbPassword from "@/components/template/PasswordTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AccountSecurity',
  setup(__props) {

  const accountStore = useAccountStore()
  const authenticateStore = useAuthenticationStore()
  const addEmail = ref(false)
  const addOTP = ref(false)
  const changePassword = ref(false)
  const toDisable = ref(false)
  const toMigrate = ref(false)
  const toDelete = ref(false)
  const email = ref("")
  const otp = ref("")
  const reason = ref("")
  const deleteInput = ref("")
  const password = ref("")
  const newPassword = ref("")
  const rePassword = ref("")
  const nbf = ref(jwt.generateNBF())

  const emailSchema = generateSchema([
    {
      name: "email",
      rule: "corporateEmail",
    },
  ])

  const sixDigitCode = generateSchema([
    {
      name: "otp",
      rule: "sixDigitCode",
    },
  ])

  const passwordSchema = generateSchema(
    [
      {
        name: "password",
        rule: "stringRequired",
      },
      {
        name: "new_password",
        rule: "password",
      },
      {
        name: "re_password",
        rule: "stringRequired",
      },
    ],
    { from: "new_password", to: "re_password", label: "Password" }
  )
  /**
   * reset add email on modal
   */
  const onReset = () => {
    addOTP.value = false
    addEmail.value = false
    changePassword.value = false
    email.value = ""
    otp.value = ""
    password.value = ""
    newPassword.value = ""
    rePassword.value = ""
  }

  /**
   * request to connect
   * @param val - validate data
   */
  const onAddEmail = (val: any) => {
    val["type"] = accountStore.type === "professional" ? "employee" : "professional"
    accountStore.linkAccount(val, nbf.value).then((success) => {
      if (success) {
        addEmail.value = false
        addOTP.value = true
      }
    })
  }

  /**
   * resend OTP
   */
  const resendOTP = () => {
    accountStore.linkAccount({ email: email.value, type: accountStore.type === "professional" ? "employee" : "professional" }, nbf.value)
  }

  /**
   * link account
   * @param val - validate data
   */
  const LinkageAccount = (val: any) => {
    val["type"] = accountStore.type === "professional" ? "employee" : "professional"
    val["email"] = email.value
    accountStore.linkAccount(val, nbf.value).then((success) => {
      if (success) {
        accountStore.listOfAccounts.push(val)
      }
    })
    onReset()
  }
  /**
   * request api to change password
   * @param val - data that validated successfully
   */
  const onChangePassword = (val: any) => {
    authenticateStore.changePassword({ password: val.new_password, old_password: val.password }, nbf.value).then((success) => {
      if (success) initialize()
    })
    onReset()
  }

  /**
   * update account to disable
   */
  const onDisable = () => {
    accountStore.status = "deactivate"
    accountStore.updateAny(nbf.value)
    nextTick(() => {
      authenticateStore.logout()
    })
  }

  /**
   * account deletion
   */
  const onDelete = () => {
    accountStore.deleteCompanyUserAccount(reason.value, nbf.value)
    nextTick(() => {
      authenticateStore.logout()
    })
  }

  /**
   * account deletion
   */
  const onMigration = async () => {
    const migrated = await accountStore.migrateAccount()
    if (migrated) {
      toMigrate.value = false
      accountStore.hide_migration_banner = true
      accountStore.updateAny(jwt.generateNBF())
      const toast = await toastController.create({
        message: "Successfully migrated account details.",
        duration: 3000,
        position: "top",
        color: "success",
      })
      await toast.present()
    } else {
      const toast = await toastController.create({
        message: "You don't have an account in workbean.co",
        duration: 3000,
        position: "top",
        color: "danger",
      })
      await toast.present()
      accountStore.hide_migration_banner = true
      accountStore.updateAny(jwt.generateNBF())
    }
  }

  /**
   * convert string to masked string
   * @param val- string to mask
   * @return masked string
   */
  const getMasked = (val: string) => {
    const match = val.match(/.+@(.+)/)
    if (match?.length && match[1]) return `*****@${match[1] || "email.com"}`
    else "*****"
  }

  const initialize = async () => {
    const loading = await loadingController.create({
      spinner: null,
      message: "Loading...",
      translucent: true,
      backdropDismiss: false,
    })
    await loading.present()
    await accountStore.retrieveCustomerAccount()
    await accountStore.getLinkedAccount()
    loading.dismiss()
  }

  onBeforeMount(initialize)

return (_ctx: any,_cache: any) => {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, { class: "px-3" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButtons), null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_icon, {
                  class: "text-3xl text-gray-300",
                  icon: _unref(arrowBackCircle),
                  onClick: _cache[0] || (_cache[0] = () => _unref(router).back())
                }, null, 8, ["icon"]),
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(IonContent), { class: "pb-10" }, {
      default: _withCtx(() => [
        (_unref(accountStore).type === 'professional')
          ? (_openBlock(), _createBlock(CardTemplate, {
              key: 0,
              class: "mx-4 my-6 flex flex-col gap-4"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(accountStore).listOfAccounts, (acct) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: acct.email,
                    class: "border border-gray-highlight p-4 rounded-[8px]"
                  }, _toDisplayString(getMasked(acct.email)), 1))
                }), 128)),
                (_unref(accountStore).type === 'professional' || (_unref(accountStore).type === 'employee' && _unref(accountStore).listOfAccounts.length === 0))
                  ? (_openBlock(), _createBlock(_component_ion_button, {
                      key: 0,
                      expand: "block",
                      color: "white",
                      type: "button",
                      "native-type": "button",
                      class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base w-full",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (addEmail.value = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Add " + _toDisplayString(_unref(accountStore).type === "professional" ? "Company" : "Workbean") + " Email", 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(CardTemplate, { class: "mx-4 my-6 flex flex-col gap-4" }, {
          default: _withCtx(() => [
            _hoisted_3,
            _createVNode(_component_ion_button, {
              expand: "block",
              color: "white",
              type: "button",
              "native-type": "button",
              class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base w-full",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (changePassword.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Change password")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_unref(accountStore).type === 'professional' && !_unref(accountStore).hide_migration_banner)
          ? (_openBlock(), _createBlock(CardTemplate, {
              key: 1,
              class: "mx-4 my-6 flex flex-col gap-4"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("p", null, _toDisplayString(_unref(accountStore).hide_migration_banner ? "Account details migrated / Current account details were retained" : "Are you an OG beanie? Migrate your data from the old Workbean."), 1),
                _createVNode(_component_ion_button, {
                  disabled: _unref(accountStore).hide_migration_banner,
                  expand: "block",
                  color: "white",
                  type: "button",
                  "native-type": "button",
                  class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base w-full",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (toMigrate.value = true))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Migrate")
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(CardTemplate, { class: "mx-4 my-6 flex flex-col gap-4 mb-20" }, {
          default: _withCtx(() => [
            _hoisted_5,
            _hoisted_6,
            _hoisted_7,
            _createVNode(_component_ion_button, {
              expand: "block",
              color: "white",
              type: "button",
              "native-type": "button",
              class: "text-white bg-primary-violet font-bold rounded-[4px] shadow-base w-full",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (toDisable.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Disable Account")
              ]),
              _: 1
            }),
            _createVNode(_component_ion_button, {
              expand: "block",
              color: "white",
              type: "button",
              "native-type": "button",
              class: "text-primary-violet font-bold rounded-[4px] shadow-base w-full",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (toDelete.value = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Delete Account")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonModal), { "is-open": addEmail.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonContent), { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(FormTemplate, {
                    "validation-schema": _unref(emailSchema),
                    class: "flex flex-col text-center gap-5",
                    "initial-values": { email: '' },
                    onReset: onReset,
                    onValid: onAddEmail
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", _hoisted_9, "Add New " + _toDisplayString(_unref(accountStore).type === "professional" ? "Company" : "Workbean") + " Email", 1),
                      _createVNode(WbInput, {
                        modelValue: email.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((email).value = $event)),
                        name: "email",
                        placeholder: `${_unref(accountStore).type === 'professional' ? 'Company' : 'Workbean'} Email`
                      }, null, 8, ["modelValue", "placeholder"]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "white",
                          type: "button",
                          "native-type": "button",
                          class: "text-black bg-white rounded-[4px] shadow-base w-full",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (addEmail.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Maybe later")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "white",
                          type: "submit",
                          "native-type": "submit",
                          class: "text-white bg-primary-violet rounded-[4px] shadow-base w-full"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Verify")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createVNode(_unref(IonModal), { "is-open": addOTP.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonContent), { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(FormTemplate, {
                    "validation-schema": _unref(sixDigitCode),
                    class: "flex flex-col text-center gap-5",
                    "initial-values": { otp: '' },
                    onReset: onReset,
                    onValid: LinkageAccount
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h3", _hoisted_12, "Verify " + _toDisplayString(_unref(accountStore).type === "professional" ? "Company" : "Workbean") + " Email", 1),
                      _createElementVNode("p", null, "Please enter the 6 digit code sent to " + _toDisplayString(email.value), 1),
                      _createVNode(SixDigitTemplate, {
                        modelValue: otp.value,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((otp).value = $event)),
                        name: "otp",
                        class: "mx-auto"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("p", null, [
                        _createTextVNode("Didn’t receive an email? "),
                        _createElementVNode("span", {
                          class: "text-primary-violet font-medium underline",
                          onClick: resendOTP
                        }, "Resend code.")
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "white",
                          type: "button",
                          "native-type": "button",
                          class: "text-black bg-white rounded-[4px] shadow-base w-full",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (addOTP.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Back")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "white",
                          type: "submit",
                          "native-type": "submit",
                          class: "text-white bg-primary-violet rounded-[4px] shadow-base w-full"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Continue")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createVNode(_unref(IonModal), { "is-open": changePassword.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonContent), { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(FormTemplate, {
                    "validation-schema": _unref(passwordSchema),
                    class: "flex flex-col text-center gap-5",
                    "initial-values": { password: '', new_password: '', re_password: '' },
                    onReset: onReset,
                    onValid: onChangePassword
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _createVNode(WbPassword, {
                        modelValue: password.value,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((password).value = $event)),
                        name: "password",
                        placeholder: "Old Password"
                      }, null, 8, ["modelValue"]),
                      _createVNode(WbPassword, {
                        modelValue: newPassword.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((newPassword).value = $event)),
                        name: "new_password",
                        placeholder: "New Password"
                      }, null, 8, ["modelValue"]),
                      _createVNode(WbPassword, {
                        modelValue: rePassword.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((rePassword).value = $event)),
                        name: "re_password",
                        placeholder: "Re Password"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "white",
                          type: "button",
                          "native-type": "button",
                          class: "text-black bg-white rounded-[4px] shadow-base w-full",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (changePassword.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cancel")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_button, {
                          expand: "block",
                          color: "white",
                          type: "submit",
                          "native-type": "submit",
                          class: "text-white bg-primary-violet rounded-[4px] shadow-base w-full"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Update")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["validation-schema"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createVNode(_unref(IonModal), { "is-open": toMigrate.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonContent), { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      type: "button",
                      "native-type": "button",
                      class: "text-black bg-white rounded-[4px] shadow-base w-full",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (toMigrate.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      type: "button",
                      "native-type": "button",
                      class: "text-white bg-primary-violet rounded-[4px] shadow-base w-full",
                      onClick: onMigration
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Migrate")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createVNode(_unref(IonModal), { "is-open": toDisable.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonContent), { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      type: "button",
                      "native-type": "button",
                      class: "text-black bg-white rounded-[4px] shadow-base w-full",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (toDisable.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      type: "button",
                      "native-type": "button",
                      class: "text-white bg-primary-violet rounded-[4px] shadow-base w-full",
                      onClick: onDisable
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Disable")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createVNode(_unref(IonModal), { "is-open": toDelete.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonContent), { class: "ion-padding" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _hoisted_27,
                  _createVNode(WbInput, {
                    modelValue: reason.value,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((reason).value = $event)),
                    name: "reason",
                    placeholder: "Reason of deletion",
                    class: "mb-5"
                  }, null, 8, ["modelValue"]),
                  _hoisted_28,
                  _createVNode(WbInput, {
                    modelValue: deleteInput.value,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((deleteInput).value = $event)),
                    name: "delete",
                    class: "mb-10",
                    placeholder: "delete"
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("div", _hoisted_29, [
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      type: "button",
                      "native-type": "button",
                      class: "text-black bg-white rounded-[4px] shadow-base w-full",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (toDelete.value = false))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      color: "white",
                      type: "button",
                      "native-type": "button",
                      class: "text-white bg-warning rounded-[4px] shadow-base w-full",
                      disabled: deleteInput.value !== 'delete',
                      onClick: onDelete
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Delete")
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"])
      ]),
      _: 1
    })
  ], 64))
}
}

})